import type { ItemDeDownload } from '@/hooks/use-bandeja-de-downloads'

export function obterTituloDaBandeja(itens: ItemDeDownload[]): string {
  const emAndamento = itens.filter(
    item => item.status === 'baixando' || item.status === 'comprimindo'
  ).length

  if (emAndamento > 0) return `Baixando ${emAndamento} arquivo(s)`

  const naFila = itens.filter(item => item.status === 'na-fila').length

  if (naFila > 0) return `Aguardando ${naFila} arquivo(s)`

  if (itens.some(item => item.status === 'erro')) {
    return 'Erro no(s) download(s)'
  }

  return 'Download(s) concluído(s)'
}
